import Cropper from 'cropperjs';

export default function (element) {
    function cropBlock(el) {
        let node = $(el);
        let button = node.find('.js-crop-download');
        let txt = node.find('.js-size-text');
        let image = node.find('.js-crop-img')[0];
        let cropper = new Cropper(image, {zoomable: false});

        image.addEventListener('crop', (event) => {
            txt.text(Math.round(event.detail.width) + 'x' + Math.round(event.detail.height));
            button.attr('href', '#');
            button.css('opacity', 0.5);

            cropper.getCroppedCanvas().toBlob(function (blob) {
                button.attr('href', URL.createObjectURL(blob));
                button.css('opacity', 1);
            });
        });

        $('.js-size-select').on({
            click: function () {
                let size = $(this).data('size').split('x');
                cropper.setData({
                    x: 0,
                    y: 0,
                    width: parseInt(size[0]),
                    height: parseInt(size[1]),
                });

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    cropBlock(element);
};